import { useState, useEffect } from 'react'
import { Flex } from '@radix-ui/themes'
import { format } from 'date-fns'
import { ja } from 'date-fns/locale'
import { Checkbox } from '@/components/subscription/checkbox'
import { SubscriptionInventory, SubscriptionSchedule } from '~/api-client/data-contracts'
import * as styles from './styles.css'

type Props = {
  schedules: SubscriptionSchedule[]
  perMonth: number
  weekday: number
  maxPerMonth: number
  onChange: (params: { perMonth: number; weekday: number }) => void
}

function formatDeliverWeekday(schedule: SubscriptionSchedule) {
  return format(new Date(1000 * schedule.attributes.deliver_at[0]), 'EEEE', { locale: ja })
}

export const ScheduleSelector: React.FC<Props> = ({ schedules, perMonth, weekday, maxPerMonth, onChange }) => {
  const options = Object.groupBy(schedules, (schedule) => formatDeliverWeekday(schedule))
  const weekdays = Object.keys(options).sort((w) => (w === '水曜日' || w === '木曜日' ? -1 : 1))
  const perMonths = [1, 2, 4].filter((time) => time <= maxPerMonth)

  return (
    <>
      {weekdays.length > 1 && (
        <div className={styles.card}>
          <Flex direction="column" align="start" gap="4px">
            <p className={styles.heading}>受け取りたい曜日を選んでください</p>
            <Flex direction="column" align="start" gap="4px">
              {weekdays.map((w, index) => {
                const value = w === '水曜日' || w === '木曜日' ? 2 : 5

                return (
                  <Checkbox key={index} checked={weekday === value} onChange={() => onChange({ perMonth, weekday: value })}>
                    {w}
                  </Checkbox>
                )
              })}
            </Flex>
          </Flex>
        </div>
      )}
      <div className={styles.card}>
        <Flex direction="column" align="start" gap="4px">
          <p className={styles.heading}>受け取りたい頻度を選んでください</p>
          <Flex direction="column" align="start" gap="4px">
            {perMonths.map((time) => (
              <Checkbox key={time} checked={perMonth === time} onChange={() => onChange({ perMonth: time, weekday })}>
                月に{time}回
              </Checkbox>
            ))}
          </Flex>
          <p className={styles.note}>※1配送ごとに2,970円がかかります</p>
        </Flex>
      </div>
    </>
  )
}
